<template>
    <div class="hddialog-sdapk-frame">
        <div class="hddialog-sdapk-container">
            <img src="/assets/pwa/popup_icon001.png" class="sdapk-banner" />
            <div class="hddialog-sdapk-content hddialog-sdapk-content1">
                <img src="/assets/pwa/popup_bg.png" class="sdapk-bg" />
                <div class="sdapk-tips-frame">
                    <div class="sdapk-tips-frame-text">{{ t('您要下载并安装APP吗') }}</div>
                </div>
                <div class="sdapk-cancel-frame" @click="handleCancel">
                    <span class="sdapk-cancel-frame-text">{{ t('取消') }}</span>
                </div>
                <div class="sdapk-install-frame" id="sdapk-install-frame" @click="handleInstall">
                    <span class="sdapk-install-frame-text">{{ t('确定') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import useApp from 'core/hooks/useApp';
import { ref } from 'vue';

const { t } = useApp();

const emit = defineEmits(['cancel', 'install']);

const handleCancel = () => {
    emit('cancel');
};

const handleInstall = () => {
    emit('install');
};
</script>

<style scoped lang="scss">
.hddialog-sdapk-frame {
    // width: 10rem;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column;
    flex-flow: column;
}

.hddialog-sdapk-container {
    position: relative;
    height: 11rem;
    width: 100%;
}

.hddialog-sdapk-container .hddialog-sdapk-content,
.hddialog-sdapk-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.hddialog-sdapk-container .hddialog-sdapk-content {
    position: absolute;
    top: 1.76rem;
    width: 8.4rem;
    height: 6.5rem;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.25);
    -webkit-box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25);
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25);
    border-radius: 0.44rem;
}

.hddialog-sdapk-container .hddialog-sdapk-content1 {
    background: #fff;
}

.hddialog-sdapk-container .sdapk-bg {
    position: absolute;
    top: -0.2rem;
    left: 0;
    width: 100%;
}

.hddialog-sdapk-container .sdapk-banner {
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -4.2rem;
    width: 8.4rem;
    z-index: 3;
}

.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-tips-frame {
    position: absolute;
    top: 2.5rem;
    width: 7rem;
    height: 2rem;
    overflow: hidden;
}

.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-tips-frame-text {
    top: 50%;
    margin-top: -1rem;
    left: 50%;
    margin-left: -3.5rem;
    width: 7rem;
    height: 2rem;
    text-align: center;
    color: rgba(0, 0, 0, 0.85);
    font-size: 0.373rem;
    line-height: 0.5rem;
    overflow-x: hidden;
    overflow-y: scroll;
}

.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-install-frame,
.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-tips-frame-text {
    position: absolute;
    font-weight: 400;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-install-frame {
    right: 0.9rem;
    bottom: 0.8rem;
    width: 3rem;
    height: 0.88rem;
    border-radius: 0.15rem;
    background: #fba531;
    border: 1px solid #fba531;
    color: #fff;
    font-size: 0.32rem;
    -webkit-transition: -webkit-transform 0.1s ease-in-out;
    transition: -webkit-transform 0.1s ease-in-out;
    transition: transform 0.1s ease-in-out;
    transition:
        transform 0.1s ease-in-out,
        -webkit-transform 0.1s ease-in-out;
}

.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-install-frame:active {
    opacity: 0.45;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
}

.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-install-frame-text {
    color: #fff;
    font-size: 0.346rem;
    font-weight: 400;
}

.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-cancel-frame {
    position: absolute;
    left: 0.9rem;
    bottom: 0.8rem;
    width: 3rem;
    height: 0.88rem;
    border-radius: 0.15rem;
    background: transparent;
    border: 1px solid #fba531;
    color: #111;
    font-size: 0.346rem;
    font-weight: 400;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transition: -webkit-transform 0.1s ease-in-out;
    transition: -webkit-transform 0.1s ease-in-out;
    transition: transform 0.1s ease-in-out;
    transition:
        transform 0.1s ease-in-out,
        -webkit-transform 0.1s ease-in-out;
}

.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-cancel-frame:active {
    opacity: 0.45;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
}

.hddialog-sdapk-container .hddialog-sdapk-content .sdapk-cancel-frame-text {
    color: #111;
    font-size: 0.346rem;
    font-weight: 400;
}

.hddialog-fapp-frame {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column;
    flex-flow: column;
}

.hddialog-fapp-container,
.hddialog-fapp-frame {
    width: 10rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    overflow: hidden;
}

.hddialog-fapp-container {
    position: relative;
    min-height: 10rem;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.hddialog-fapp-container .hddialog-fapp-content {
    position: relative;
    width: 6.66rem;
    background: rgba(0, 0, 0, 0.25);
    -webkit-box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25);
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25);
    border-radius: 0.44rem;
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
}

.hddialog-fapp-container .hddialog-fapp-content1 {
    background: #fff;
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);
    border-radius: 0.66rem;
    backdrop-filter: blur(0);
    -webkit-backdrop-filter: blur(0);
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-banner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border-radius: 0.66rem 0.66rem 0 0;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-banner-icon {
    position: absolute;
    top: 1.6rem;
    left: 50%;
    margin-left: -0.89rem;
    width: 1.78rem;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-tips-frame {
    position: relative;
    margin-top: 2rem;
    width: 6rem;
    height: auto;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-tips-frame-text {
    position: relative;
    margin-top: 3.7rem;
    left: 50%;
    margin-left: -2.7rem;
    width: 5.4rem;
    text-align: left;
    color: rgba(0, 0, 0, 0.85);
    font-size: 0.373rem;
    line-height: 0.54rem;
    font-weight: 400;
    word-wrap: break-word;
    white-space: pre-wrap;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-tips-frame-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-account-frame {
    position: absolute;
    top: 8.94rem;
    width: 6.22rem;
    height: 0.88rem;
    border-radius: 0.5rem;
    background: rgba(0, 0, 0, 0.25);
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    white-space: nowrap;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-account-frame-title {
    font-weight: 400;
    color: hsla(0, 0%, 100%, 0.65);
    font-size: 0.3rem;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-account-frame-icon {
    margin-left: 0.12rem;
    width: 0.66rem;
    height: 0.66rem;
    border: 0.5px solid hsla(0, 0%, 100%, 0.45);
    border-radius: 0.5rem;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-account-frame-value {
    margin-left: 0.12rem;
    color: hsla(0, 0%, 100%, 0.85);
    font-size: 0.32rem;
    font-weight: 700;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-install-frame {
    position: relative;
    margin-top: 0.66rem;
    margin-bottom: 1rem;
    left: 50%;
    margin-left: -1.67rem;
    width: 3.34rem;
    height: 1.11rem;
    border-radius: 0.33rem;
    background: #007aff;
    color: #fff;
    font-size: 0.373rem;
    font-weight: 400;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transition: -webkit-transform 0.1s ease-in-out;
    transition: -webkit-transform 0.1s ease-in-out;
    transition: transform 0.1s ease-in-out;
    transition:
        transform 0.1s ease-in-out,
        -webkit-transform 0.1s ease-in-out;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-install-frame:active {
    opacity: 0.45;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-install-frame-text {
    color: #fff;
    font-size: 0.373rem;
    font-weight: 400;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-install-frame-icon {
    width: 0.66rem;
    height: 0.66rem;
    margin-right: 0.2rem;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-cs {
    position: absolute;
    top: 0.3rem;
    left: 0.44rem;
    width: 0.66rem;
    height: 0.66rem;
    border-radius: 0.5rem;
    background: #007aff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    z-index: 2;
    -webkit-transition: -webkit-transform 0.1s ease-in-out;
    transition: -webkit-transform 0.1s ease-in-out;
    transition: transform 0.1s ease-in-out;
    transition:
        transform 0.1s ease-in-out,
        -webkit-transform 0.1s ease-in-out;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-cs:active {
    opacity: 0.45;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-cs-icon {
    width: 0.4rem;
    height: 0.4rem;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-close {
    position: absolute;
    top: 0.22rem;
    right: 0.22rem;
    width: 0.66rem;
    height: 0.66rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    z-index: 2;
    background: #fff;
    border-radius: 0.4rem;
    -webkit-transition: -webkit-transform 0.1s ease-in-out;
    transition: -webkit-transform 0.1s ease-in-out;
    transition: transform 0.1s ease-in-out;
    transition:
        transform 0.1s ease-in-out,
        -webkit-transform 0.1s ease-in-out;
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-close:active {
    opacity: 0.45;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
}

.hddialog-fapp-container .hddialog-fapp-content .fapp-close-icon {
    width: 0.55rem;
    height: 0.55rem;
}
</style>
